import { Input, type InputProps } from "@/components/ui/input"
import { examples } from "@/lib/sundries/examples"

export const EmailInput = (props: InputProps) => (
  <Input {...props} placeholder={props.placeholder ?? examples.person.email} />
)
